import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveWorkloadRequestPending(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isPending : false;
    },
    isRetrieveWorkloadRequestSuccess(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isSuccessful : false;
    },
    isRetrieveWorkloadRequestFailure(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isFailure : false;
    },
    getWorkloadContent(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.content : [];
    },
    getWorkloadCurrentPage(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.currentPage : 0;
    },
    canLoadMoreWorkload(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.canLoadMore : true;
    },
    getWorkloadTotalElements(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.totalElements : 0;
    },
  };
}

export { createSelector };
